import * as React from 'react';

import PickListContext from 'src/context/pickListContext';
import { Input, Radio, Select } from 'antd';
import CheckboxGroup from 'antd/lib/checkbox/Group';
import DropdownInput from './DropdownInput';

interface IProps {
	style?: {};
	// disabled?: boolean;
	placeholder?: string;
	name: string;
	fieldId: number;
	type: string;
	options?: string[]; // "value1, value2, value3"
	value?: string;
	onChange: (e: any) => void;
	dataLocked?: boolean;
}

const { Option } = Select;

class CustomFieldElement extends React.Component<IProps, {}> {
	public static contextType = PickListContext;

	public render() {
		let element: JSX.Element;
		if (this.props.type === undefined) {
			return ('');
		}
		const type = this.props.type.toLowerCase();
		switch (type) {
			case 'input':
				element = (
					<Input
						onChange={this.onInputChange}
						name={this.props.name}
						id={this.props.name}
						placeholder={this.props.placeholder}
						value={this.props.value!}
						disabled={this.props.value === 'Redacted' ? true : false || this.props.dataLocked}
						style={this.props.style}
					/>
				);
				break;
			case 'dropdown': {
				if (this.props.options![0] !== '') {
					this.props.options!.unshift('');
				}
				
				element = (
					<Select
						id={this.props.name}
						disabled={this.props.value === 'Redacted' ? true : false || this.props.dataLocked}
						onChange={this.onSelectChange}
						placeholder={this.props.placeholder}
						value={this.props.value}
						style={{width: 254}}
						dropdownMatchSelectWidth={false}
					>
						{
							this.props.options!.map((opt) => {
								return (
									<Option key={opt} value={opt}>
										{opt}
									</Option>
								);
							})
						}
					</Select>
				);
				break;
			}

			case 'checkbox': {
				const stringArray = this.props.value!.split(',');
				const filteredOptions = this.props.value === 'Redacted' ? this.props.options!.filter(opt => opt === 'Redacted') : this.props.options!;
				element = (
					<CheckboxGroup
						onChange={this.onCheckBoxChange}
						disabled={this.props.value === 'Redacted' ? true : false || this.props.dataLocked}
						value={stringArray}
						options={filteredOptions}
						style={this.props.style}
					/>
					);
				break;
			}
			case 'radiogroup': {
				const filteredOptions = this.props.value === 'Redacted' ? this.props.options!.filter(opt => opt === 'Redacted') : this.props.options!;
				element = (
					<Radio.Group
						name={this.props.name}
						disabled={this.props.value === 'Redacted' ? true : false || this.props.dataLocked}
						onChange={this.onRadioGroupChange}
						value={this.props.value}
						style={this.props.style}
					>
					{filteredOptions.map(opt => (<Radio key={opt} value={opt}>{opt}</Radio>))}
					</Radio.Group>
				);
				break;
			}
			default:
				element = <div />;
		}
		return (
			<div>{element}</div>
		);
	}

	private onInputChange = (e: any) => {
		e.target.fieldId = this.props.fieldId;
		this.props.onChange(e);
	}

	private onSelectChange = (e: any) => {
		if (this.props.options![0] === '') {
			this.props.options!.shift();
		}
		const changeValue =  {target: {fieldId: this.props.fieldId, name: this.props.name, value: e}};
		this.props.onChange(changeValue);
	}

	private onCheckBoxChange = (e: any) => {
		const newEventValue = e.join(','); // remove comma at beginning of string
		const updatedValueWithOutCommma = (newEventValue.length && newEventValue[0] === ',') ? newEventValue.slice(1) : newEventValue;
		const newEvent = { target: { fieldId: this.props.fieldId, name: this.props.name, value: updatedValueWithOutCommma } };

		this.props.onChange(newEvent);
	}

	private onRadioGroupChange = (e: any) => {
		e.target.fieldId = this.props.fieldId;
		this.props.onChange(e);
	}
}

export default CustomFieldElement;